import Assets from '../../assets';

export default {
  title: 'Gestión tributaria y contable',
  image: Assets.InicioBackground,
};
